export default __webpack_public_path__ + "static/4erBoxen.blue.bg-7afbb6574de61950dfd3d39d88ffbfd5.jpg";